import type { AppDirective } from './types';

const Directive: AppDirective = {
    Name: 'app-disabled' as const,
    Directive(el, bindings)
    {
        if(bindings.value) {
            el.classList.add('disabled-ui');
            el.classList.add('disabled');
    
            el.title = bindings.value;
        }
    }
};

export default Directive;
